import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { translate } from 'parking-react-common'

import { invitations, users, ui, api } from '../redux'

import UserDisplay from '../components/UserDisplay'
import List from '../components/List'
import Button from '../components/Button'
import TZDateTime from './TZDateTime'

const InvitationsList = ({ dataURL, dataSelector, dispatch, t }) => {
    const columns = [
        {
            key    : 'referred',
            title  : t('User'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ cellData } />
            )
        },
        {
            key    : 'moment',
            title  : t('Sent At'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key    : 'resend',
            title  : t('Resend'),
            render : ({ rowData }) => ( // eslint-disable-line react/prop-types
                <Button
                    intent={ ui.INTENT.primary }
                    size={ ui.SIZE.large }
                    icon="md/cached"
                    onClick={ () => dispatch(api.update(api.buildURL('invitations', { id: rowData.id }))) }
                />
            )
        },
        {
            key    : 'delete',
            title  : t('Delete'),
            render : ({ rowData }) => ( // eslint-disable-line react/prop-types
                <Button
                    intent={ ui.INTENT.error }
                    size={ ui.SIZE.large }
                    icon="md/delete-forever"
                    onClick={ () => dispatch(api.destroy(api.buildURL('invitations', { id: rowData.id }))) }
                />
            )
        }
    ]

    return (
        <List
            title={ t('Invitations') }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ users.getSearchKeys('referred') }
        />
    )
}

InvitationsList.propTypes = {
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string,
    dispatch     : PropTypes.func.isRequired
}

InvitationsList.defaultProps = {
    dataSelector : invitations.getAll,
    dataURL      : 'invitations'
}

export default translate()(connect()(InvitationsList))
